import {CSSProperties, useContext} from "react"
import { ConfigContext } from "../../config_context";


export default function HouseEinfamilienhaus(props: {
  selected_menu_item: string;
  onEnterElement: (id: string) => void;
  onLeaveElement: (id: string) => void;
  onClickElement: (id: string) => void;
  element_styling_function: (id: string) => CSSProperties;
  icon_styling_function: (id: string) => CSSProperties;
  outline_styling_function: (id: string) => CSSProperties;
}) {
  const base_asset_url = useContext(ConfigContext).base_asset_url;

  const enter_element = props.onEnterElement;
  const leave_element = props.onLeaveElement;
  const click_element = props.onClickElement;
  const element_styling_function = props.element_styling_function;
  const icon_styling_function = props.icon_styling_function;
  const outline_styling_function = props.outline_styling_function; 

  return (  
    <>
  {/*BEGIN SVG*/}
    <svg  viewBox="0 0 3000 3000">
  <defs>
    <style>{`
      .efh-cls-10 {
        isolation: isolate;
      }

      .efh-cls-11 {
        clip-path: url(#clippath-17);
      }

      .efh-cls-12 {
        clip-path: url(#clippath-19);
      }

      .efh-cls-13 {
        clip-path: url(#clippath-11);
      }

      .efh-cls-14 {
        clip-path: url(#clippath-16);
      }

      .efh-cls-15 {
        clip-path: url(#clippath-18);
      }

      .efh-cls-16 {
        clip-path: url(#clippath-10);
      }

      .efh-cls-17 {
        clip-path: url(#clippath-15);
      }

      .efh-cls-18 {
        clip-path: url(#clippath-13);
      }

      .efh-cls-19 {
        clip-path: url(#clippath-14);
      }

      .efh-cls-20 {
        clip-path: url(#clippath-12);
      }

      .efh-cls-21 {
        mix-blend-mode: multiply;
      }

      .efh-cls-22 {
        clip-path: url(#clippath-1);
      }

      .efh-cls-23 {
        clip-path: url(#clippath-3);
      }

      .efh-cls-24 {
        clip-path: url(#clippath-4);
      }

      .efh-cls-25 {
        clip-path: url(#clippath-2);
      }

      .efh-cls-26 {
        clip-path: url(#clippath-7);
      }

      .efh-cls-27 {
        clip-path: url(#clippath-6);
      }

      .efh-cls-28 {
        clip-path: url(#clippath-9);
      }

      .efh-cls-29 {
        clip-path: url(#clippath-8);
      }

      .efh-cls-30 {
        clip-path: url(#clippath-5);
      }

      .efh-cls-38 {
        clip-path: url(#clippath);
      }
    `}</style>
    <clipPath id="clippath">
      <rect className="efh-cls-1" x="402.36" y="137.68" width="2135.13" height="1242.85"></rect>
    </clipPath>
    <clipPath id="clippath-1">
      <polygon className="efh-cls-1" points="344.42 921.51 2579.64 923.76 2579.64 58.42 344.42 56.16 344.42 921.51"></polygon>
    </clipPath>
    <clipPath id="clippath-2">
      <rect className="efh-cls-1" x="939.89" y="175.75" width="914.61" height="554.58"></rect>
    </clipPath>
    <clipPath id="clippath-3">
      <rect className="efh-cls-1" x="1791.11" y="220.29" width="594.07" height="464.81"></rect>
    </clipPath>
    <clipPath id="clippath-4">
      <rect className="efh-cls-1" x="500.1" y="415.99" width="1941.12" height="823.06"></rect>
    </clipPath>
    <clipPath id="clippath-5">
      <rect className="efh-cls-1" x="500.1" y="415.99" width="1941.12" height="823.06"></rect>
    </clipPath>
    <clipPath id="clippath-6">
      <rect className="efh-cls-1" x="684.65" y="452.7" width="119.59" height="530.86"></rect>
    </clipPath>
    <clipPath id="clippath-7">
      <rect className="efh-cls-1" x="648.93" y="1312.3" width="1263.1" height="734.94"></rect>
    </clipPath>
    <clipPath id="clippath-8">
      <rect className="efh-cls-1" x="1404.05" y="1102" width="348.79" height="652.27"></rect>
    </clipPath>
    <clipPath id="clippath-9">
      <rect className="efh-cls-1" x="911.42" y="816.04" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-10">
      <rect className="efh-cls-1" x="1560.58" y="79.43" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-11">
      <rect className="efh-cls-1" x="1332.62" y="351.68" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-12">
      <rect className="efh-cls-1" x="2000.64" y="351.52" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-13">
      <rect className="efh-cls-1" x="458.34" y="973.97" width="1772.2" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-14">
      <rect className="efh-cls-1" x="458.34" y="973.97" width="1772.2" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-15">
      <rect className="efh-cls-1" x="662.08" y="579.57" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-16">
      <rect className="efh-cls-1" x="1158.86" y="1618.96" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-17">
      <rect className="efh-cls-1" x="1158.86" y="1618.96" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-18">
      <rect className="efh-cls-1" x="1158.86" y="1618.96" width="121.62" height="121.62"></rect>
    </clipPath>
    <clipPath id="clippath-19">
      <rect className="efh-cls-1" x="1621.4" y="1178.97" width="121.62" height="498.33"></rect>
    </clipPath>
  </defs>
  
  <g className="efh-cls-10">
    <g id="Ebene_1">
      <g>
        <g id="interaktive_flaechen">
          <polygon id="fassade" className="efh-cls-5" points="700.69 100.65 405.69 780.04 406.98 783.87 399.32 1220.62 753.69 1353.12 798.38 1343.54 790.72 920.2 1159.78 994.26 1768.94 915.72 1768.94 1366.52 1792.89 1372.26 2519.65 1182.44 2519.2 775.25 1157.55 904.54 700.69 100.65" onPointerEnter={()=>{enter_element("fassade")}} onPointerLeave={()=>{leave_element("fassade")}} onClick={()=>{click_element("fassade")}} style={element_styling_function("fassade")}></polygon>
          <polygon id="dach" className="efh-cls-32" points="689.2 64.9 352.06 783.87 404.41 781.33 428.69 723.84 697.83 98.42 1159.15 905.62 2578.8 767.27 2065.85 173.45 689.2 64.9" onPointerEnter={()=>{enter_element("dach")}} onPointerLeave={()=>{leave_element("dach")}} onClick={()=>{click_element("dach")}} style={element_styling_function("dach")}></polygon>
          <polygon id="photovoltaik" className="efh-cls-3" points="954.28 184.63 945.25 195.62 1274.08 732.7 1838.12 692.24 1848.75 683.73 1516.72 217.6 954.28 184.63" onPointerEnter={()=>{enter_element("photovoltaik")}} onPointerLeave={()=>{leave_element("photovoltaik")}} onClick={()=>{click_element("photovoltaik")}} style={element_styling_function("photovoltaik")}></polygon>
          <polygon id="solarthermie" className="efh-cls-35" points="1804.55 238.71 1800.86 248.62 2161.63 694.38 2382.99 675.21 2380.85 664.58 2027.53 251.66 1804.55 238.71" onPointerEnter={()=>{enter_element("solarthermie")}} onPointerLeave={()=>{leave_element("solarthermie")}} onClick={()=>{click_element("solarthermie")}} style={element_styling_function("solarthermie")}></polygon>
          <path id="fenster" className="efh-cls-8" d="M640.37,941.26l-129.3-19.15v207.53l129.3,38.32v-226.7h0ZM597.25,735.35l73.43,7.97v-236.25h-70.23l-3.2,228.27h0ZM806.38,756.1l73.43,7.97-1.6-247.42h-70.23l-1.6,239.45h0ZM1924.84,665.12l136.21-12.77-174.53-229.87-138.35,2.14,176.65,240.51h.02,0ZM2089.25,1155.7l2.14-231.99-170.27,19.15-8.51,246.9,176.65-34.06h0ZM2436.19,869.43l-172.41,27.66,4.8,331.51,164.41-41.51,3.2-317.66h0Z" onPointerEnter={()=>{enter_element("fenster")}} onPointerLeave={()=>{leave_element("fenster")}} onClick={()=>{click_element("fenster")}} style={element_styling_function("fenster")}></path>
          <polygon id="lueftung" className="efh-cls-4" points="694.63 328.29 696.86 966.49 744.12 975.43 805.41 971.6 804.13 928.17 755.29 917.32 753.69 328.29 694.63 328.29" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={element_styling_function("lueftung")}></polygon>
          <polygon id="keller" className="efh-cls-34" points="651.54 1753.78 1160.75 2031.54 1903.04 1766.55 1903.04 1345.14 1767.34 1364.29 1765.74 1343.54 1175.12 1488.79 793.61 1345.14 748.89 1354.72 656.31 1318 651.54 1753.78" onPointerEnter={()=>{enter_element("keller")}} onPointerLeave={()=>{leave_element("keller")}} onClick={()=>{click_element("keller")}} style={element_styling_function("keller")}></polygon>
          <path id="heizung" className="efh-cls-7" d="M1765.74,1341.94l-587.44,146.87-383.11-146.87-3.2-420.15,367.14,74.69,609.79-79.18-3.2,424.61.02.02h0ZM1669.96,1741.01l-47.89,19.15-122.92-41.51,1.6-175.59-79.81-20.75,1.6-33.52,135.69-33.52,114.27-27.14-2.55,312.88h.01Z" onPointerEnter={()=>{enter_element("heizung")}} onPointerLeave={()=>{leave_element("heizung")}} onClick={()=>{click_element("heizung")}} style={element_styling_function("heizung")}></path>
        </g>
        <g id="Rahmen">
          <g id="fassade_rahmen" style={outline_styling_function("fassade")}>
            <g className="efh-cls-38">
              <path className="efh-cls-37" d="M1788.29,1380.51l-.99-25.3-28.27-9.64-.32-412.85-600.64,75.8-31.22-6.4-320.47-65.62-4.75,409.2-52.55,9.89-1.78-.68-344.89-131.5v-444.65l.68-1.4L713.15,137.68l6.28,11.53,414.9,762.33,26.58,6.65,1376.58-153.96-1.76,411.11-109.2,21.85-.07-8.18-2.07-305.11-146.28,21.47-6.4,337.19h-31.51l-1.33-.61c-.47-.2-46.13-20.86-66-22.84-18.07-1.8-44.87,4.64-77.56,18.65-24.24,10.38-17.39,47.44-17.32,47.82l1.24,6.28-6.22,1.58-163.67,41.42-2.14,17.07-118.98,28.56h.07v.02ZM1765.76,1340.73l28.09,9.57.86,21.71h0l106.41-25.54,2.12-17.03,168.15-42.57h0c-.09-.43-8.04-42.78,21.29-55.35,33.72-14.46,61.7-21.08,80.89-19.15,20.93,2.09,67.19,23,68.09,23.4h23.43l6.37-336.28,159.64-23.4,2.14,312.88,95.78-19.15,1.71-398h0l-1370.25,153.24-30.66-7.66-.7-1.31L713.48,152.46h0l-304.37,627.88v438.46l340.54,129.84h0l45.23-8.51,4.8-411.83,358.65,73.43,607.11-76.63.32,415.69v-.06Z"></path>
            </g>
          </g>
          <g id="dach_rahmen" style={outline_styling_function("dach")}>
            <g className="efh-cls-22">
              <path className="efh-cls-37" d="M1152.98,921.51l-27.28-9.91-173.87-315.09-240.35-435.55-300.81,620.4h0l-1.85,3.81h-64.42l4.6-9.66L691.03,56.14l4.64.36,1364.42,108.24,1.8,2.09,495.72,574.11,19.78-.2-7.7,22.62-4.03.45-1412.71,157.68.05.02h-.02ZM1130.39,906.1l23.4,8.51,1411.14-157.5,2-8.38-12.12-.65-1.17-1.35-496.89-575.46L695.13,63.26h0l-340,715.14h49.49L711.1,146.27l419.29,759.83h0Z"></path>
            </g>
          </g>
          <g id="photovoltaik_rahmen" style={outline_styling_function("photovoltaik")}>
            <g className="efh-cls-25">
              <path className="efh-cls-37" d="M1262.25,730.33l-2.09-3.49L939.89,194.36l3.49-18.61,5.95.36,562.87,33.07,1.87,2.59,340.43,469.52-19.17,16.76-2.32.14-570.75,32.17v-.02h-.01ZM947.01,193.05h0l318.94,530.3,566.68-31.92,12.77-11.17-336.82-464.52-559.67-32.89-1.91,10.2h.02,0Z"></path>
            </g>
          </g>
          <g id="solarthermie_rahmen" style={outline_styling_function("solarthermie")}>
            <g className="efh-cls-23">
              <path className="efh-cls-37" d="M2149.35,685.12l-2.23-2.77-356.04-446.01,5.34-16.04,228.99,12.57,359.73,426.86-18.2,9.71-1.44.09-216.16,15.59h0ZM1798.67,234.97l353.74,443.15,212.62-15.32,9.57-5.11-352.46-418.23-220.93-12.14-2.55,7.66h0Z"></path>
            </g>
          </g>
          <g id="fenster_rahmen" style={outline_styling_function("fenster")}>
            <g className="efh-cls-24">
              <g>
                <path className="efh-cls-37" d="M2256.57,1239.05v-349.66l5.81-.83,175.61-24.71,1.31,314.48,1.94,1.28v15.34l-184.64,44.08-.02.02h-.01ZM2263.33,895.26v335.23l171.13-40.86v-6.4l-1.91-1.28-1.28-310.31-167.93,23.63h-.01Z"></path>
                <path className="efh-cls-37" d="M1904.12,1198.66v-258.84l189.76-26.11v223.57l3.49,2.09-1.35,17.48-4.91,1.06-186.98,40.73v.02h0ZM1910.87,945.7v244.56l178.79-38.95.63-8.29-3.2-1.91v-219.65l-176.24,24.26.02-.02h0Z"></path>
                <g className="efh-cls-30">
                  <g>
                    <path className="efh-cls-37" d="M664.99,743.31l-85.17-10.65v-14.26l3.22-1.94,1.94-218.9,89.43,2.25v236.74l-9.44,6.74.02.02ZM586.57,726.7h0l76.63,9.57h0l4.46-3.2v-226.67l-75.98-1.91h0l-1.91,215.82-3.2,1.91v4.48h0Z"></path>
                    <path className="efh-cls-37" d="M876.95,771.15l-103.5-14.17-2.09-14.71,4.55-1.89,1.94-237.67,104.14,2.21v253.75l-5,12.5-.02-.02h-.02ZM779.42,750.96l93.23,12.77,2.55-6.37v-245.82l-90.67-1.91h0l-1.91,235.3-3.83,1.6.63,4.46v-.02h0Z"></path>
                    <path className="efh-cls-37" d="M635.07,1173.27l-134.97-43.83,2.52-15.23h4.78l1.94-209.78,130.31,28.47-.65,227.58-3.92,12.77v.02h-.01ZM507.71,1124.8l122.92,39.92,1.62-5.25.63-221.11-116.84-25.54-1.91,208.16h-5.74l-.63,3.83h-.05Z"></path>
                    <path className="efh-cls-37" d="M1914.64,677.46l-181.96-245.69,11.29-15.79h3.49l138.04.68,2.03,2.61,181.06,234.29-10.2,15.86-143.71,8.06-.02-.02h-.02ZM1741.03,431.69l176.87,238.82,136.64-7.66,5.74-8.94-178.15-230.5-134.73-.63h0l-6.37,8.94h0v-.02h0Z"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="lueftung_rahmen" style={outline_styling_function("lueftung")}>
            <g className="efh-cls-27">
              <g>
                <path className="efh-cls-37" d="M751.69,513.79l-65.77-2.41.83-58.68,66.61.81-1.64,60.3-.02-.02h0ZM692.76,504.87l52.35,1.91,1.28-46.61-53-.63-.63,45.34v-.02h0Z"></path>
                <path className="efh-cls-37" d="M735.58,983.56l-50.93-13.09.79-54.8,12.03-4.01,51.11,10.5,1.85,2.77,31.2-3.02.99-3,21.62,2.7v54.67l-21.42,2.86-1.33-5.34-30.18,2.84-1.31,5.83-14.39,1.1-.02-.02h0ZM691.48,965.25l44.69,11.49,8.31-.63,1.28-5.74,40.86-3.83,1.28,5.11,9.57-1.28v-42.78l-10.23-1.28-.63,1.91-39.58,3.83-2.57-3.83-46.61-9.57-5.74,1.91-.63,44.69h-.02.02Z"></path>
              </g>
            </g>
          </g>
          <g id="keller_rahmen" style={outline_styling_function("keller")}>
            <g className="efh-cls-26">
              <path className="efh-cls-37" d="M1162.08,2047.24l-404.49-227.85-9.01.65-1.82-1.08-97.85-57.51v-3.87l1.33-445.29,103.69,39.83,41.47-8.92,1.85.68,388.18,143.58,582.96-143.01,20.12,7.32,1.28,19.42,3.11,1.33,119.12-26.92v428.21l-115.85,42.53-6.37.32-627.72,230.59h.02-.02ZM759.12,1812.53l403.55,227.31,625.74-229.87,6.37-.32,110.47-40.55v-415.03l-113.01,25.54-8.94-3.83-1.28-19.15-14.06-5.11-582.96,143.04-.97-.36-389.17-143.94-41.49,8.94-96.41-37.03-1.28,435.46,94.49,55.55,8.94-.63.02-.02h0Z"></path>
            </g>
          </g>
          <g id="heizung_rahmen" style={outline_styling_function("heizung")}>
            <g className="efh-cls-29">
              <g>
                <path className="efh-cls-37" d="M1736.89,1334.51l-21.85-5.05v-33.79l-.63-.16-112.45-28.11,1.37-160.67,19.98-4.75,1.44.27,106.39,21.02,1.53,2.55c6.51.23,11.04,1.04,13.47,2.39,3.18,1.78,5.56,5.29,6.37,9.44.81,4.14-.07,8.24-2.46,11.24-4.17,5.23-10.47,4.53-13.81,4.03l.63,181.58v.02h.02ZM1721.82,1324.1l8.31,1.91-.63-180.7,3.87.56c.92.14,1.91.09,3.2.29l.29.05c3.29.5,6.17.72,7.95-1.51,1.13-1.42,1.53-3.51,1.1-5.7-.43-2.19-1.6-4.03-3.02-4.84-1.22-.68-5.07-1.44-12.19-1.58l-1.87-.05-1.91-3.18-103.44-20.43h0l-13.43,3.2-1.28,150.04h0l107.27,26.83,5.74-1.28v36.4l.02-.02h.02Z"></path>
                <path className="efh-cls-37" d="M1614.87,1754.28l-35.09-2.07-1.08-.45-83.98-35.32-.99-6.98c-1.19-1.08-3.02-2.64-4.69-3.94l-2.57-2.03-.63-193.47-34.94-11.56-1.76.61s-7.68,2.68-13.85,4.03c-3.42.77-6.1.79-8.29.09l-6.01,1.71c-4.21,1.19-11.87,1.4-15.93-10.74-1.89-5.72-1.17-10.52,2.28-15.14,2.64-3.51,7.5-6.37,8.45-6.92l1.46-.61c21.08-6.19,26.65-5.95,29.31-4.89,3.54,1.42,6.04,4.57,7.66,7.37l33.97,10.52c.95-6.67,1.76-11.06,2.43-13.11.23-.65.5-1.28.86-1.91l-25.9-9.71,47.89-13.15,2.16.9c12.28,5.16,23.52,9.3,25.66,9.69.38,0,.77-.07,1.24-.14h.25c4.32-.56,12.41-1.53,34.13,2.82,14.66,2.93,22.62,7.28,25.07,13.63.14.34.25.68.34,1.01l1.01.36v-10.47l-74.69-22.17,52.17-12.73,75.64,20.32v21.58l-24.24,7.86-.59,4.53,16.85,4.37-1.28,20.63-16.29,4.39v2.66l37.66,12.14v204.31l-5.11,1.28v3.31l-48.57,17.39h-.01ZM1581.33,1745.54l32.57,1.91,42.78-15.32v-3.83l5.11-1.26v-194.1l-37.66-12.14v-12.77l16.6-4.46.63-10.23-17.23-4.48,1.91-14.69,23.63-7.66v-11.49l-68.97-18.52-26.17,6.37h0l58.12,17.23-2.55,3.83v20.43l-14.03-4.89-.09-2.3c0-.43-.11-.86-.27-1.28-1.01-2.66-5.34-6.46-20.07-9.42-20.66-4.12-28.04-3.24-32.01-2.77h-.25c-.86.14-1.55.2-2.23.2-4.46-.29-27.86-10.11-28.09-10.2h0l-25.54,7.03,16.38,6.15-4.55,3.72c-1.17.95-1.91,1.94-2.25,2.91-.65,1.94-1.62,7.7-2.68,15.81l-.52,3.96-44.29-13.7-.65-1.28c-1.42-2.82-3.2-4.8-4.84-5.45-.59-.18-4.57-.88-24.91,5.11h0c-1.55.88-4.87,3.09-6.37,5.11-2.09,2.79-2.46,5.38-1.28,8.94,2.61,7.82,6.01,6.85,7.66,6.37l8.38-2.39,1.17.61c.63.32,2.05.56,5.11-.11,5.79-1.28,13-3.81,13.09-3.83h0l.32-2.57,45.34,15,.63,195.07c1.94,1.51,4.66,3.81,6.08,5.23l.79.79.79,5.47,80.46,33.83-.02.02-.03.04Z"></path>
              </g>
            </g>
          </g>
        </g>
        <g id="Icons">
          <g id="fassade-2" onPointerEnter={()=>{enter_element("fassade")}} onPointerLeave={()=>{leave_element("fassade")}} onClick={()=>{click_element("fassade")}} style={icon_styling_function("fassade")}>
            <g>
              <g className="efh-cls-28">
                <path className="efh-cls-6" d="M972.21,937.66c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              </g>
              <path className="efh-cls-31" d="M995.14,872.58v-22.89h-45.84v22.89h-19.53v29.33h84.88v-29.33h-19.53.02ZM956.04,856.45h32.32v15.81h-32.32v-15.81ZM936.53,895.15v-15.81h32.28v15.81h-32.28ZM1007.89,895.15h-32.28v-15.81h32.28v15.81Z"></path>
            </g>
          </g>
          <g id="dach-2" onPointerEnter={()=>{enter_element("dach")}} onPointerLeave={()=>{leave_element("dach")}} onClick={()=>{click_element("dach")}} style={icon_styling_function("dach")}>
            <g className="efh-cls-16">
              <path className="efh-cls-6" d="M1621.4,201.05c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
            </g>
            <path className="efh-cls-31" d="M1667.64,159.2l-16.6-41.02h-57.21l.07.18-15.45,37.08,6.24,2.59,12.82-30.75,12.93,31.92h57.21-.01ZM1646.49,124.93l11.13,27.5h-42.64l-11.13-27.5s42.64,0,42.64,0Z"></path>
          </g>
          <g id="photovoltaik-2" onPointerEnter={()=>{enter_element("photovoltaik")}} onPointerLeave={()=>{leave_element("photovoltaik")}} onClick={()=>{click_element("photovoltaik")}} style={icon_styling_function("photovoltaik")}>
            <g id="icon">
              <g className="efh-cls-13">
                <path className="efh-cls-6" d="M1393.44,473.29c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
              </g>
              <polygon className="efh-cls-31" points="1394.3 386.03 1410.04 386.03 1395.35 409.14 1415.67 409.14 1380.04 445.95 1392.36 420.31 1378.73 420.31 1394.3 386.03"></polygon>
            </g>
          </g>
          <g id="solarthermie-2" onPointerEnter={()=>{enter_element("solarthermie")}} onPointerLeave={()=>{leave_element("solarthermie")}} onClick={()=>{click_element("solarthermie")}} style={icon_styling_function("solarthermie")}>
            <g className="efh-cls-20">
              <g>
                <path className="efh-cls-6" d="M2061.46,473.13c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
                <path className="efh-cls-31" d="M2049.56,401.55c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.74,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.02Z"></path>
                <path className="efh-cls-31" d="M2049.56,421.53c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.76,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.04Z"></path>
                <path className="efh-cls-31" d="M2049.56,441.53c-7.43,0-14.73-3.36-19.03-8.78l5.29-4.21c3.02,3.78,8.4,6.24,13.76,6.24,4.17,0,7.61-1.44,9.71-4.08,3.18-3.99,8.33-6.19,14.51-6.19h0c8.45,0,17.19,4.12,22.28,10.5l-5.29,4.21c-3.78-4.75-10.61-7.95-16.98-7.95h0c-4.08,0-7.34,1.31-9.21,3.65-3.4,4.28-8.72,6.62-15,6.62h-.04Z"></path>
              </g>
            </g>
          </g>
          <g id="fenster-2" onPointerEnter={()=>{enter_element("fenster")}} onPointerLeave={()=>{leave_element("fenster")}} onClick={()=>{click_element("fenster")}} style={icon_styling_function("fenster")}>
            <g className="efh-cls-18">
              <path className="efh-cls-36" d="M519.13,1095.58c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
            </g>
            <path className="efh-cls-31" d="M538.17,1061.61h-38.07v-26.38h6.89v12.21h6.76v-18.97h-13.65v-20.52h38.07v53.66h0ZM493.34,1068.37h51.58v-67.17h-51.58v67.17h0Z"></path>
            <g className="efh-cls-19">
              <path className="efh-cls-36" d="M2169.72,1095.58c33.59,0,60.8-27.23,60.8-60.82s-27.23-60.82-60.8-60.82-60.8,27.23-60.8,60.82,27.23,60.82,60.8,60.82"></path>
            </g>
            <path className="efh-cls-31" d="M2188.75,1061.61h-38.07v-26.38h6.89v12.21h6.76v-18.97h-13.65v-20.52h38.07v53.66h0ZM2143.92,1068.37h51.58v-67.17h-51.58v67.17Z"></path>
          </g>
          <g id="lueftung-2" onPointerEnter={()=>{enter_element("lueftung")}} onPointerLeave={()=>{leave_element("lueftung")}} onClick={()=>{click_element("lueftung")}} style={icon_styling_function("lueftung")}>
            <g className="efh-cls-17">
              <g>
                <path className="efh-cls-37" d="M722.9,701.18c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
                <path className="efh-cls-31" d="M736.71,619.28c.54-7.66-5.14-17.41-12.68-21.78v31.47c0,6.69,1.69,11.13,3.78,9.91,3.76-2.18,8.9-10.25,8.9-19.6"></path>
                <path className="efh-cls-31" d="M711.34,662.87c-.54,7.66,5.14,17.41,12.68,21.78v-31.47c0-6.69-1.69-11.13-3.78-9.91-3.76,2.18-8.9,10.25-8.9,19.6"></path>
                <path className="efh-cls-31" d="M702.24,628.38c-7.66-.54-17.41,5.14-21.78,12.68h31.47c6.69,0,11.13-1.69,9.91-3.78-2.18-3.76-10.25-8.9-19.6-8.9"></path>
                <path className="efh-cls-31" d="M745.83,653.74c7.66.54,17.41-5.14,21.78-12.68h-31.47c-6.69,0-11.13,1.69-9.91,3.78,2.18,3.76,10.25,8.9,19.6,8.9"></path>
              </g>
            </g>
          </g>
          <g id="keller-2" onPointerEnter={()=>{enter_element("keller")}} onPointerLeave={()=>{leave_element("keller")}} onClick={()=>{click_element("keller")}} style={icon_styling_function("keller")}>
            <g className="efh-cls-14">
              <g>
                <g className="efh-cls-11">
                  <path className="efh-cls-6" d="M1219.66,1740.58c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
                </g>
                <path className="efh-cls-31" d="M1250.88,1689.72h-62.44v-33.77l30.12-13.76,32.3,13.7v33.83h.02,0ZM1195.19,1682.96h48.93v-22.59l-25.45-10.79-23.47,10.72v22.66h-.01Z"></path>
                <rect className="efh-cls-31" x="1188.43" y="1689.36" width="6.76" height="24.51"></rect>
                <rect className="efh-cls-31" x="1244.12" y="1689.36" width="6.76" height="24.51"></rect>
                <rect className="efh-cls-31" x="1188.8" y="1696.27" width="58.7" height="6.76"></rect>
                <g className="efh-cls-15">
                  <g className="efh-cls-21">
                    <g>
                      <path className="efh-cls-9" d="M1232.72,1634.93"></path>
                      <path className="efh-cls-2" d="M1232.72,1634.93"></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="heizung-2" onPointerEnter={()=>{enter_element("heizung")}} onPointerLeave={()=>{leave_element("heizung")}} onClick={()=>{click_element("heizung")}} style={icon_styling_function("heizung")}>
            <g className="efh-cls-12">
              <g>
                <path className="efh-cls-33" d="M1682.2,1677.31c33.59,0,60.82-27.23,60.82-60.82s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.82,60.82,60.82"></path>
                <path className="efh-cls-31" d="M1652.42,1599.5c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1652.42,1644.13c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
                <path className="efh-cls-31" d="M1675.23,1599.5c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1675.23,1644.13c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
                <path className="efh-cls-31" d="M1698.05,1599.5c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1698.05,1644.13c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
                <path className="efh-cls-31" d="M1718.37,1599.5c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1718.37,1613.78c-5.81,0-10.52-4.71-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.71,10.52,10.52-4.71,10.52-10.52,10.52"></path>
                <path className="efh-cls-33" d="M1682.2,1300.59c33.59,0,60.82-27.23,60.82-60.8s-27.23-60.82-60.82-60.82-60.82,27.23-60.82,60.82,27.23,60.8,60.82,60.8"></path>
                <path className="efh-cls-31" d="M1652.42,1222.78c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1652.42,1267.41c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
                <path className="efh-cls-31" d="M1675.23,1222.78c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1675.23,1267.41c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
                <path className="efh-cls-31" d="M1698.05,1222.78c-1.69,0-3.04,1.37-3.04,3.06v31.76c0,1.69,1.37,3.04,3.04,3.04s3.04-1.37,3.04-3.04v-31.76c0-1.69-1.37-3.06-3.04-3.06M1698.05,1267.41c-5.41,0-9.8-4.39-9.8-9.8v-31.76c0-5.41,4.39-9.82,9.8-9.82s9.8,4.39,9.8,9.82v31.76c0,5.41-4.39,9.8-9.8,9.8"></path>
                <path className="efh-cls-31" d="M1718.37,1222.78c-2.07,0-3.76,1.69-3.76,3.76s1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76-1.69-3.76-3.76-3.76M1718.37,1237.07c-5.81,0-10.52-4.73-10.52-10.52s4.71-10.52,10.52-10.52,10.52,4.73,10.52,10.52-4.71,10.52-10.52,10.52"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
    {/*END SVG*/}
    <div className={"house-img einfamilienhaus-img"} style={{
          backgroundImage: 'url("'+base_asset_url+'/einfamilienhaus.jpg")',
    }}></div>
  </>);
}


